<template>
  <v-container grid-list-xl>
    <v-layout row justify-center align-center wrap class="mt-4 pt-2">
      <v-dialog
        v-model="project.dialog"
        lazy
        max-width="1000"
        v-for="project in projects"
        :key="project.title"
      >
        <template v-slot:activator="{ on }">
          <v-flex xs12 sm6 md4 lg4 xl4 v-on="on">
            <v-card hover flat color="transparent">
              <v-img
                :src="project.poster"
                :alt="project.title"
                height="230"
                lazy-src="https://cdn.dribbble.com/users/503653/screenshots/3143656/fluid-loader.gif"
              ></v-img>
              <v-card-title primary-title class="justify-center">{{project.title}}</v-card-title>
            </v-card>
          </v-flex>
        </template>
        <v-card v-if="project.dialog">
          <v-img :src="project.poster"></v-img>
          <v-card-text>
            <h3 class="headline mb-0">
              <span>Technology</span>
            </h3>
            <v-chip color="green" v-if="project.tech.tech1" text-color="white">{{project.tech.tech1}}</v-chip>
            <v-chip color="green" v-if="project.tech.tech2" text-color="white">{{project.tech.tech2}}</v-chip>
            <v-chip color="green" v-if="project.tech.tech3" text-color="white">{{project.tech.tech3}}</v-chip>
            <v-chip color="green" v-if="project.tech.tech4" text-color="white">{{project.tech.tech4}}</v-chip>
          </v-card-text>
          <v-card-actions>
            <v-btn v-if="project.git" flat large dark color="green" :href="project.git" target="_blank">
              <v-icon left>fab fa-github</v-icon>GitHub
            </v-btn>
            <v-btn large flat dark color="green" :href="project.demo" target="_blank">
              <v-icon left>fas fa-desktop</v-icon>Demo
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  metaInfo: {
    title: "Portfolio",
    titleTemplate: "%s ← Alan's Website",
    meta: [
      { name: "viewport", content: "width=device-width, initial-scale=1" },
      {
        name: "description",
        content:
          "Alan Devalis' Portfolio Web Development Blockchain Front-End Full-Stack"
      },
      { charset: "utf-8" },
      { property: "og:title", content: "Alan's Website" },
      { property: "og:site_name", content: "Alan's Website" },
      { property: "og:type", content: "website" },
      { property: "og:url", content: "https://alandevalis.netlify.app/" },
      {
        property: "og:image",
        content: "https://i.imgur.com/1NjG3uj.png"
      },
      {
        property: "og:description",
        content:
          "Alan Devalis' Portfolio Web Development Video Editing Graphic Design Front-End Advetising"
      }
    ]
  },
  data() {
    return {
      dialog: false,
      projects: [
        {
          dialog: false,
          title: "YOMI Website",
          demo: "https://yomi.digital/",
          tech: {
            tech1: "VUE",
            tech2: "Javascript"
          },
          poster: "https://i.imgur.com/CRZQgOO.png?1"
        },
        {
          dialog: false,
          title: "AGOS Website",
          demo: "https://agos.global/",
          tech: {
            tech1: "Bootstrap",
            tech2: "Javascript"
          },
          poster: "https://i.imgur.com/ipvT2sf.png"
        },
        {
          dialog: false,
          title: "NFT Minting Web",
          git: "https://github.com/devalis1/KingdomFace_NFT_MintingWeb",
          demo: "https://kingdomface.netlify.app/",
          tech: {
            tech1: "Solidity",
            tech2: "JavaScript",
            tech3: "web3",
            tech4: "Blockchain"
          },
          poster: "https://i.imgur.com/SA9s2My.png"
        },
        {
          dialog: false,
          title: "Patient Booking System",
          git: "https://github.com/devalis1/PatientsBookingSystem",
          demo: "https://aedpatientbookingsystem.netlify.app/",
          tech: {
            tech1: "React",
            tech2: "Tailwind",
            tech3: "Vite"
          },
          poster: "https://i.imgur.com/idJxisg.png"
        },
        {
          dialog: false,
          title: "RoboPunks Minting Web",
          git: "https://github.com/devalis1/Punk_NFT_MintingWeb",
          demo: "https://punk-nft-minting.netlify.app/",
          tech: {
            tech1: "React",
            tech2: "Javascript",
            tech3: "ethers.js",
            tech4: "Blockchain"
          },
          poster: "https://i.imgur.com/MxU7eEP.png"
        }
      ]
    }
  }
}
</script>

<style lang="scss" scoped>
</style>